export default {
  facebook: {
    en: 'Facebook',
  },
  google: {
    en: 'Google',
  },
  whatsApp: {
    en: 'WhatsApp',
  },
}
